import { SM } from '../assets/data/enum/storeModel.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'verdeview',
    textName: 'VerdeView',
    indexPage: 'loading',
    welcomeUserCheck: false,
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=verdeview',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=verdeview',
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
      SM.SM_LOAD,
      SM.SM_SILOS,
      SM.SM_NUTRITION,
      SM.SM_IRRIGATE,
      SM.SM_PATHOGEN,
      SM.SM_INSECTS,
      SM.SM_CROP_PLANNING,
      SM.SM_BATCH,
      SM.SM_SUSTAINABILITY,
      SM.SM_NUTRITION_FREE,
    ],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    versionPublicPage: 'v1',
    store: false,
  },
  apiBaseUrl: 'https://api-verdeview.xfarm.ag/',
  SSOfrontAppCallback: 'https://verdeview.ctemolise.it/#/oauthCheck?token=',
  launchDarklyKey: '67604b96a30d7b094c8dd80f',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/verdeview/',
  palette: {
    '--p-xfarm-50': '#d4d6de',
    '--p-xfarm-100': '#aaaebe',
    '--p-xfarm-200': '#81879f',
    '--p-xfarm-300': '#596381',
    '--p-xfarm-400': '#324164',
    '--p-xfarm-500': '#2e3b5a',
    '--p-xfarm-600': '#2a3550',
    '--p-xfarm-700': '#262f46',
    '--p-xfarm-800': '#22293c',
    '--p-xfarm-900': '#1d2333',
    '--p-xfarm-950': '#191d2a',
  },
  primary: '#324164',
  primaryOpacity: '#324164',
  primaryOpacity15: '#32416426',
  secondary: '#556FA9',
  backgroundSplashScreen: '#FFFFFF',
  spinnerSplashScreen: '#324164',
  navBarColor: '#324164',
  colorSidebarHeader: '#556FA9',
  textLoginVersion: '#FFFFFF',
  btnSuccess: '#324164',
};
